import api from "./api";

// Fase 4.3 v1.5 — Tags personalizaveis pro painel Rostand. Tenant isolado
// pelo JWT do `api` (companyId injetado no backend). Sao chamadas leves
// (poucas tags por tenant), nao precisa cache.

export const listRescueTags = async () => {
  const { data } = await api.get("/rescue-tags");
  return data;
};

export const createRescueTag = async (payload) => {
  const { data } = await api.post("/rescue-tags", payload);
  return data;
};

export const updateRescueTag = async (id, payload) => {
  const { data } = await api.put(`/rescue-tags/${id}`, payload);
  return data;
};

export const deleteRescueTag = async (id) => {
  const { data } = await api.delete(`/rescue-tags/${id}`);
  return data;
};

// Substitui (replace) as tags atribuidas a um lead. body { tagIds: [...] }.
export const setLeadRescueTags = async (leadId, tagIds) => {
  const { data } = await api.put(`/rescue-leads/${leadId}/tags`, { tagIds });
  return data;
};
